import { faCompass } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledFeature,
  StyledFeatures,
  StyledWrapper
} from './CompassFeatures.styled';

const CompassFeatures: React.FC = () => {
  const { t } = useI18n('salary-compass');
  const { locale } = useRouter();

  const features = [
    {
      title: t('salary-compass.features.market-info.title'),
      desc: t('salary-compass.features.market-info.desc'),
      image: getPublicPath('/images/salaryCompass/market-info.svg')
    },
    {
      title: t('salary-compass.features.reliability.title'),
      desc: t('salary-compass.features.reliability.desc'),
      image: getPublicPath('/images/salaryCompass/reliability.svg')
    },
    {
      title: t('salary-compass.features.data.title'),
      desc: t('salary-compass.features.data.desc'),
      image: getPublicPath('/images/salaryCompass/data.svg')
    },
    {
      title: t('salary-compass.features.simulation.title'),
      desc: t('salary-compass.features.simulation.desc'),
      image: getPublicPath('/images/salaryCompass/simulation.svg')
    }
  ];

  return (
    <StyledWrapper>
      <StyledContainer>
        <Heading1 as="h2" editorial>
          {t('salary-compass.features.title')}
        </Heading1>
        <StyledFeatures>
          {features.map((feature, index) => (
            <StyledFeature key={index}>
              <img src={feature.image} alt="" />
              <h3>{feature.title}</h3>
              <p>{feature.desc}</p>
            </StyledFeature>
          ))}
        </StyledFeatures>
        <Link href={`${getAppUrl(APP_URLS.salaryBenchmark, locale)}`} passHref>
          <ButtonLink variant="brandTalent">
            <span>{t('salary-compass.features.cta')}</span>
            <FontAwesomeIcon icon={faCompass} />
          </ButtonLink>
        </Link>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default CompassFeatures;
